<div class="card shadow">
  <div class="card-body">
    <app-table-header-template [searchOptions]="CardsSearchOptions">
      <ng-container filter>
        <app-cards-filter (filterApplied)="onFilterApplied($event)"></app-cards-filter>
      </ng-container>
      <ng-container buttons>
        <div class="row align-items-center">
          <div class="col-auto">
            <div class="reduce-size-90">
              <app-toggle-switch
                [class]="'table-switch'"
                [hideIcon]="true"
                [disabled]="filterApplied()"
                [initialValue]="!showHideRemoved()"
                [label]="'Show all'"
                [id]="'hideInactiveCategoriesSwitch'"
                (switchChange)="onToggleHideRemoved()">
              </app-toggle-switch>
            </div>
          </div>
          <div class="col-auto">
            <button
              (click)="onCreate()"
              class="btn btn-primary btn-sm">
              Create
            </button>
          </div>
        </div>
      </ng-container>
    </app-table-header-template>

    <app-table
      #table
      [columns]="columns"
      [getDataCallback]="getData"
      class="table-subscription-cards"
      emptyMessage="Your Subscription cards will appear here.">
      <ng-template
        #cardNameCell
        let-value="value">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-0">
            <app-avatar [firstName]="value"></app-avatar>
          </div>
          <div class="col">{{ value }}</div>
        </div>
      </ng-template>

      <ng-template
        #expiryCell
        let-value="value">
        {{ value | date: 'dd/MM/yyyy' | emptyIndicator }}
      </ng-template>

      <ng-template
        #statusCell
        let-value="value">
        <app-status-badge
          [value]="value"
          [department]="statusBadgeDepartments.CARDS"></app-status-badge>
      </ng-template>

      <ng-template
        #balanceCell
        let-value="value">
        {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
      </ng-template>

      <ng-template
        #actions
        let-row="row">
        <div class="row justify-content-end">
          <div class="col-auto">
            <button
              (click)="goToRemoveCard(row.id)"
              [disabled]="row.status === CardStatus.Removed"
              class="btn-action">
              <i class="pays-icon ic-bin"></i>
            </button>
          </div>
          <div class="col-auto">
            <button
              (click)="onViewCard(row.id)"
              class="btn-action">
              <i class="iconoir-nav-arrow-right"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet />
</div>

@if (!hasSubscriptionCardsFeature()) {
  <app-upgrade-to-premium-overlay type="subscription-card"></app-upgrade-to-premium-overlay>
}
